import { z } from "zod";

export const STRATEGIC_TAXONOMY = ["ACF", "OCIO", "HHS", "Zero Trust", "CX", "Data"];

export const DemandSchema = z.object({
  demandId: z.string().min(1, "Missing demandId"),
  title: z.string().min(6, "Title too short (≥6 chars)."),
  description: z.string().min(20, "Description too short (≥20 chars)."),
  businessOwner: z.string().min(3, "Business owner required."),
  sponsor: z.string().min(3, "Sponsor required."),
  directorate: z.string().min(2, "Directorate required."),
  strategicTags: z.array(z.string()).min(1, "Select ≥1 strategic tag."),
  urgency: z.enum(["Low", "Medium", "High", "Critical"]),
  expectedOutcomes: z.array(z.string()).min(1, "Add ≥1 outcome."),
  acceptanceCriteria: z
    .record(z.string())
    .refine(
      (rec) => Object.keys(rec).length > 0 && Object.values(rec).every((v) => v.trim().length > 0),
      { message: "Map ≥1 acceptance criterion to an outcome (non-empty)." }
    ),
  roiBenefit: z.string().min(2, "Provide initial ROI/benefit."),
  attachments: z.array(z.object({ name: z.string(), url: z.string().url().optional() })).optional(),
  ideaLinkage: z
    .object({
      ideaId: z.string().optional(),
      aiSummary: z.string().optional(),
      similarityCluster: z.string().optional(),
      priorScores: z.array(z.number()).optional(),
    })
    .optional(),
});
